




























































































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import {GetTenantInfo} from '../../../api/realTime'
import total from './total.vue'
import contrast from './contrast.vue'
import detail from './detail.vue'
import {GetCategory,GetCheckListByCondition,AssayYearData,AssayMonthDetail,AssayPercent} from '../../../api/realTime'

@Component({
    components: {total,contrast,detail}
})
export default class extends AbpBase {
    tipShow = true
    queryform = {
        tenantIds:[],
        itemType:'xiechanggui',
        year:this.formatDate(new Date()),
        month:0,
        itemCode:'HB',
        maxValue:0,
        minValue:0,
    }
    getItemName(code){
        return this.itemCodeOptions.find(v=>{return v.itemCode === code}).itemName
    }
    //常用项
    commmonItems = [
        {value:'HB',text:'血红蛋白',groupId:'xiechanggui'},
        {value:'CA',text:'钙',groupId:'gukuangwuzhidaixie'},
        {value:'P',text:'磷',groupId:'gukuangwuzhidaixie'},
        {value:'IPTH',text:'甲状旁腺激素',groupId:'gukuangwuzhidaixie'},
        {value:'ALB',text:'白蛋白',groupId:'shenghuajiancha'},
        {value:'K',text:'钾',groupId:'shenghuajiancha'},
        {value:'PRE-BUN',text:'透前尿素',groupId:'shenghuajiancha'},
        {value:'AFTER-BUN',text:'透后尿素',groupId:'shenghuajiancha'},
        {value:'UA',text:'尿酸',groupId:'shenghuajiancha'},
        {value:'PRE-CR',text:'透前肌酐',groupId:'shenghuajiancha'},
        {value:'AFTER-CR',text:'透后肌酐',groupId:'shenghuajiancha'},
    ]
    async commmonChange(val:any){
        this.queryform.itemCode = val
        this.queryform.itemType = this.commmonItems.find((v:any)=>{return v.value === val}).groupId
        await this.itemTypeChange()
        this.getData()
        this.getContrastData(this.cntrastDataYear,this.cntrastDataMonth)
    }
    tenantOptions = []
    itemTypeOptions = []
    itemCodeOptions = []
    //获取下拉框
    async getSelects(){
        this.tenantOptions = (await GetTenantInfo({})).data
        this.itemTypeOptions = (await GetCategory({})).data
        await this.itemTypeChange()
    }
    async itemTypeChange(){
        this.itemCodeOptions = (await GetCheckListByCondition({GroupId:this.queryform.itemType})).data
        let c = this.itemCodeOptions.find((item:any)=>{return item.itemCode === this.queryform.itemCode})
        if(!c){
            this.queryform.itemCode = this.itemCodeOptions[0].itemCode
        }
        await this.itemCodeChange()
    }
    itemCodeChange(){
        let row = this.itemCodeOptions.find((item:any)=>{return item.itemCode === this.queryform.itemCode})
        this.queryform.minValue = row.minValue
        this.queryform.maxValue = row.maxValue
    }
    searchPopShow = false
    tabs:any = [
        {closable:false,key:0,name:'医院总计'},
        {closable:false,key:0,name:'医院对比'},
    ]
    activeName = '医院总计'
    removeTab(targetName){
        let ri;
        this.tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
                let nextTab = this.tabs[index == this.tabs.length-2 ? index - 1 :index + 1] || this.tabs[index - 1];
                if (nextTab) {
                    this.activeName = nextTab.name;
                }
                ri = index
            }
        });
        this.tabs.splice(ri,1)
        this.tabChange()
    }
    tabChange(){
        let tab = this.tabs.find((item:any)=>{return item.name == this.activeName})
        if(tab.closable){
            this.getDetailData()
        }
    }
    getDetail(row:any){
        let tab = this.tabs.find((item:any)=>{return item.name == `月度报表（${row.date}）`})
        if(tab){
            this.activeName = `月度报表（${row.date}）`
            this.getData()
            return false 
        }
        this.tabs.splice(this.tabs.length-1, 0,{
            closable:true,
            key:0,
            name:`月度报表（${row.date}）`,
            year:row.date.split('-')[0],
            month:row.date.split('-')[1],
        })
        this.activeName = `月度报表（${row.date}）`
        this.getDetailData()
    }
    async created(){
        await this.getSelects()
        this.getData()
        this.getContrastData(this.formatDate(new Date).split('-')[0],this.formatDate(new Date).split('-')[1])
    }
    totalData = null
    async getData(){
        this.totalData = null
        this.queryform.year = this.queryform.year.split('-')[0]
        let res = await AssayYearData(this.queryform)
        this.totalData = res
    }
    detailData = {}
    async getDetailData(){
        let tab = this.tabs.find((item:any)=>{return item.name == this.activeName})
        console.log(tab.month)
        let data = {
            minValue: this.queryform.minValue,
            maxValue: this.queryform.maxValue,
            itemCode: this.queryform.itemCode,
            year: tab.year,
            month: tab.month
        }
        let res = await AssayMonthDetail(data)
        this.detailData = res.data
    }
    contrastData = {}
    async getContrastData(year,month){
        let data = {
            minValue: this.queryform.minValue,
            maxValue: this.queryform.maxValue,
            itemCode: this.queryform.itemCode,
            year: year,
            month: month,
            tenantIds:this.queryform.tenantIds,
        }
        let res = await AssayPercent(data)
        res.maxValue = this.queryform.maxValue
        this.contrastData = res
    }
    cntrastDataYear = this.formatDate(new Date).split('-')[0]
    cntrastDataMonth = this.formatDate(new Date).split('-')[1]
    dateChange(year,month){
        this.cntrastDataYear = year
        this.cntrastDataMonth = month
        this.getContrastData(year,month)
    }
    downxlsx(){
        let XLSX = this.$XLSX;
        var xlsxParam = { raw: true };//转换成excel时，使用原始的格式
        let a = document.createElement('div')
        a.innerHTML = document.querySelector("#mytable").outerHTML
        a.innerHTML = a.innerHTML.replace(/详情/g, '');
        var wb = XLSX.utils.table_to_book(a,xlsxParam);//mytable为表格的id名
        var wbout = XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "array"
        });
        let filename = ''
        if(this.activeName === '医院总计'){
            filename = `年度统计(${this.queryform.year}${this.getItemName(this.queryform.itemCode)})`+".xlsx"
        }else if(this.activeName === '医院对比'){
            filename = `医院对比(${this.cntrastDataYear}-${this.cntrastDataMonth}${this.getItemName(this.queryform.itemCode)})`+".xlsx"
        }else {
            filename = `${this.activeName}${this.getItemName(this.queryform.itemCode)} - 患者详情`+".xlsx"
        }
        try {
            this.$FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            filename
            );
        } catch (e) {
            if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
    }
}
